import { createSlice } from "@reduxjs/toolkit";

const AUTH_TOKEN_KEY = "jhi-authenticationToken";

export const initialState = {
  loading: false,
  isAuthenticated: false,
  roles: [],
  user: null as { username?: string; name?: string; email?: string } | null,
};

export type AuthenticationState = Readonly<typeof initialState>;

export const clearAuthToken = () => {
  if (localStorage.get(AUTH_TOKEN_KEY)) {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  }
};

// export const logout: () => AppThunk = () => dispatch => {
//   clearAuthToken();
//   dispatch(logoutSession());
// };

export const clearAuthentication = () => (dispatch) => {
  clearAuthToken();
  dispatch(clearAuth());
};

export const AuthenticationSlice = createSlice({
  name: "authentication",
  initialState: initialState as AuthenticationState,
  reducers: {
    login(state) {
      return { ...state, loading: false, isAuthenticated: true };
    },
    clearAuth(state) {
      return { ...state, isAuthenticated: false, loading: false, roles: [], user: null };
    },
    setRoles(state, action) {
      return { ...state, roles: action.payload };
    },
    setUser(state, action) {
      return { ...state, user: action.payload };
    },
  },
});

export const { clearAuth, login, setRoles, setUser } = AuthenticationSlice.actions;

// Reducer
export default AuthenticationSlice.reducer;
